import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import { CountrySearchParams, EaCountriesList } from '../models/custom-climate.model';

@Injectable({ providedIn: 'root' })
export class EaCountryService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ApiUrlInjectionToken) as string;

  search(params: CountrySearchParams): Observable<EaCountriesList> {
    return this.http.get<EaCountriesList>(`${this.baseUrl}/ea-countries`, {
      params: this.cleanParams(params),
    });
  }

  private cleanParams(p: CountrySearchParams): Record<string, string> {
    const out: Record<string, string> = {};
    out['page'] = String(p.page);
    out['pageSize'] = String(p.pageSize);
    if (p.text) out['text'] = p.text;
    if (p.orderByField) out['orderByField'] = p.orderByField;
    if (p.orderByDirection) out['orderByDirection'] = p.orderByDirection;
    if (p.continentId) out['continentId'] = p.continentId;
    return out;
  }
}
